type ModalCloseButtonProps = {
  onClick: () => void;
  disabled?: boolean;
  className?: string;
};

export default function ModalCloseButton({ onClick, disabled, className = "" }: ModalCloseButtonProps) {
  return (
    <button
      type="button"
      className={`modal-close-button ${className}`.trim()}
      onClick={onClick}
      onPointerDown={(event) => event.stopPropagation()}
      disabled={disabled}
      aria-label="Close"
      title="Close"
    >
      ×
    </button>
  );
}
